module.exports = __webpack_public_path__ + "static/media/SHSProdIcons_Ring_Doorbell.64f468be.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/homepage/resources/SHSProdIcons_Ring_Doorbell.svg
// module id = 1608
// module chunks = 0